"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaffModel = void 0;
/* eslint-disable max-len */
const CognitoStatus_1 = __importDefault(require("@opsbase/lib-auth/CognitoStatus"));
const InviteStatus_1 = __importDefault(require("@opsbase/lib-auth/InviteStatus"));
const InviteToAppStatus_1 = __importDefault(require("@opsbase/lib-auth/InviteToAppStatus"));
const StaffUserType_1 = __importDefault(require("@opsbase/lib-auth/StaffUserType"));
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const intersectionBy_1 = __importDefault(require("lodash/intersectionBy"));
const uniqBy_1 = __importDefault(require("lodash/uniqBy"));
const listTrim_1 = __importDefault(require("../helpers/listTrim"));
const stringListTrim_1 = __importDefault(require("../helpers/stringListTrim"));
const Model_1 = __importDefault(require("../Model"));
const ModelRegistry_1 = __importDefault(require("../ModelRegistry"));
class StaffModel extends Model_1.default {
    constructor(o) {
        super(o);
        this.staffType = StaffUserType_1.default.EMPLOYEE;
        this.places = [];
        this.positions = [];
        this.allPlaces = false;
        this.inviteToAppStatus = InviteToAppStatus_1.default.INVITE_NOTSENT;
        this.title = '';
        this.email = '';
        this.tel = '';
        this.address = '';
        this.locked = false;
        this.enabled = true;
        this.cognitoStatus = CognitoStatus_1.default.NOTREGISTERED;
        this.hasProfileImage = false;
        this.profileImageUrl = '';
        this.inviteStatus = InviteStatus_1.default.NOTACCEPTED;
        super.init(o);
        if (!o || !o.positions) {
            this.positions = [];
        }
        if (!o || !o.places) {
            this.places = [];
        }
    }
    get __typename() {
        return 'Staff';
    }
    set __typename(v) { }
    get avatarUrl() {
        return this.profileImageUrl;
    }
    get pending() {
        return (this.inviteStatus === InviteStatus_1.default.NOTACCEPTED &&
            this.cognitoStatus === CognitoStatus_1.default.NOTREGISTERED);
    }
    get teams() {
        return (0, uniqBy_1.default)(this.positions
            .filter(p => !!p)
            .map(p => p.team)
            .filter(p => !!p), t => t.title);
    }
    get placesStr() {
        return (0, listTrim_1.default)(this.places);
    }
    get teamsStr() {
        const teams = new Set((this.positions || [])
            .filter(p => !!p)
            .map(p => { var _a; return (_a = p.team) === null || _a === void 0 ? void 0 : _a.title; })
            .filter(p => !!p));
        return (0, stringListTrim_1.default)([...teams]);
    }
    get roleStr() {
        switch (this.staffType) {
            case StaffUserType_1.default.PRIMARYADMIN:
                return 'Primary Admin';
            case StaffUserType_1.default.ADMIN:
                return 'Admin';
            default:
                return 'Staff';
        }
    }
    isInPlace(id) {
        return this.places.findIndex(s => s.id === id) >= 0;
    }
    isUsualPosition(positionId) {
        return (this.positions || []).map(p => p.id).includes(positionId);
    }
    isInTeam(team) {
        return (0, intersectionBy_1.default)(this.positions || [], team.positions || [], p => p['id']).length > 0;
    }
}
exports.StaffModel = StaffModel;
StaffModel.ALL_FIELDS = `id, staffType, inviteStatus, allPlaces, inviteToAppStatus, enabled, lastLoggedIn,
		title, email, tel, locked, profileImageUrl, hasProfileImage,  cognitoStatus,
		preferences,
		places { id, title, timezone },
		positions { id, title, team { id, title } }`;
exports.default = StaffModel;
ModelRegistry_1.default[DataType_1.default.STAFF] = StaffModel;
